// extracted by css-extract-rspack-plugin
export default {"fallback":"YzrayEEzwwt1b4co","pulse":"UD6Dt2ZjlHgxEaZp","fullscreen":"imbExWVv15oiUVc5"};